import {InstantiationLevel} from './instantiation-level';
import {IndicatorReportType} from './indicator-report';
import {OutlookInfo} from './outlook-info';
import {IndicatorShort} from './indicator';

// This model is used to read the indicator groups with pruned indicator detail for use in populating the report dropdown.
export class IndicatorGroup {
	sortOrder: string;

	constructor(
		public group: 'All Governmental Funds' | 'General Fund' | 'Other Indicators' | string,
		public mcag: string,
		public instantiationLevel: InstantiationLevel,
		public report: IndicatorReportType,
		public filingBasis: 'Cash' | 'GAAP' | 'None',
		public outlookInfo: OutlookInfo,
		public indicators: Array<IndicatorShort>
	) {
		// Set sortOrder
		const prefix = this.group === 'General Fund' ? '1'
			: this.group === 'All Governmental Funds' ? '2' : '3';
		this.sortOrder = `${prefix}${this.group}`;
	}

}
